<template>
  <el-table-column
    prop="products"
    label="Termékek"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.products.length" type="primary"> {{ scope.row.products.length }} termék </el-tag>
      <el-tag v-else type="danger">Nincs termék</el-tag>
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'products',
  };
</script>
